export const resetPasswordStyles = theme => ({
  button: {
    margin: theme.spacing(),
  }
})